import React from "react";
import { Input } from "@/components/ui/input";

interface TitleStepProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

const TitleStep: React.FC<TitleStepProps> = ({
  value,
  onChange,
  onKeyDown,
}) => {
  return (
    <div className="relative">
      <Input
        name="title"
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder="e.g. Sunset Hike to Diamond Head"
        className="w-full text-sm font-light leading-relaxed focus-visible:outline-none focus-visible:ring-0 rounded-lg"
      />
    </div>
  );
};

export default TitleStep;
